var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`view-${_vm.$route.name}`],attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{ref:"router",staticStyle:{"animation-duration":"0.3s"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }